import { Navbar } from '@WESCO-International/wdp-ui-components/components/navbar';
import RightNavContent from './WDPRightNavContent';

export function WDPNavbar(args: any) {
  return (
    <div className={args.className}>
      <Navbar {...args} id="catalog-navbar" right={<RightNavContent />} />
    </div>
  );
}
